import { Fragment } from "react";

export type TextSegment = { text: string; highlight?: boolean };

interface HighlightedTextProps {
  segments: TextSegment[];
}

export const HighlightedText = ({ segments }: HighlightedTextProps) => {
  return (
    <>
      {segments.map((segment, idx) =>
        segment.highlight ? (
          <strong key={idx} className="text-(--color-accent-3)">
            {segment.text}
          </strong>
        ) : (
          <Fragment key={idx}>{segment.text}</Fragment>
        )
      )}
    </>
  );
};
